import { Injectable } from '@angular/core';
import { Field, SchemaService, SchemaProperty } from '../../../services/squidex';
import { DynamicSchemaModel } from './dynamic-schema.model';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicSchemaService {

  constructor(private readonly schemaService: SchemaService) { }

  addField(field: Field): Observable<DynamicSchemaModel> {
    return this.schemaService.addField(field);
  }

  updateField(field: Field, fieldId?: number): Observable<DynamicSchemaModel> {
    return this.schemaService.updateField(field, fieldId);
  }

  deleteField(fieldId: number, force: boolean = false): Observable<DynamicSchemaModel> {
    return this.schemaService.deleteField(fieldId, force);
  }

  getSchemaDefinition(): Observable<DynamicSchemaModel> {
    return this.schemaService.getSchemaDefinition();
  }


  reorderField(fieldIds: number[]): Observable<DynamicSchemaModel> {
    return this.schemaService.reorderFields(fieldIds);
  }

  disableField(fieldId: number): Observable<DynamicSchemaModel> {
    return this.schemaService.disableField(fieldId);
  }


  enableField(fieldId: number): Observable<DynamicSchemaModel> {
    return this.schemaService.enableField(fieldId);
  }


  updateSchemaProperties(properties: SchemaProperty): Observable<DynamicSchemaModel> {
    return this.schemaService.updateSchemaProperties(properties);
  }

}
